import { createUseStyles } from 'react-jss'
import { useTranslation } from "react-i18next"
import { FileModel, FileType } from "../redux/types"
import InfoCard from "./InfoCard"
import { Colors } from "../constants/colors"
import File from "./File"

interface Props {
    files: FileModel[]
    expectedIncludedEmployerCount: number
}

const CustomerGroupFilesByMonth = ({files, expectedIncludedEmployerCount}: Props) => {
    const styles = useStyles()
    const { t } = useTranslation(['files', 'common']);

    const fileFilter = (file: FileModel) => {
        if (file.type === FileType.advancePayoutBasisFile) {
            return true
        }
        if (file.type === FileType.deductionPayoutBasisFile) {
            return true
        }
        return false
    }

    const getYearAndMonth = (file: FileModel) => {
        if (file.type === FileType.advancePayoutBasisFile) {
            return `${file.advancePayoutBasisFile.year}-${padWithLeadingZeroes(file.advancePayoutBasisFile.month, 2)}`
        }

        if (file.type === FileType.deductionPayoutBasisFile) {
            return file.deductionPayoutBasisFile.paydayPaymentDate.substring(0, 7)
        }

        return ''
    }

    const renderFiles = () => {
        const filesGroupedByYearAndMonth = files?.filter(fileFilter).reduce(function (r, file) {
            const yearAndMonth = getYearAndMonth(file)
            r[yearAndMonth] = r[yearAndMonth] || [];
            r[yearAndMonth].push(file);
            return r;
        }, Object.create(null));

        const orderedList = Object.entries(filesGroupedByYearAndMonth).sort(([key1, value1]: any, [key2, value2]: any) => {
            return new Date(key2 + "-01").getTime() - new Date(key1 + "-01").getTime()
        });

        return orderedList.map(([key, value], index) => {
            const filesForPayday = value as FileModel[]
            
            return (
                <InfoCard title={getTitleFromYearAndMonthString(key)} className={styles.infoCard} key={`container_${index}`}>
                    { renderFilesCore(filesForPayday) }
                </InfoCard>
            )
        })
    }

    const getTitleFromYearAndMonthString = (str: string) => {
        const year = str.substring(0, 4)
        const monthNumber = parseFloat(str.substring(5))

        return t(`month${monthNumber}`, {ns: 'common'}) + ' ' + year
    }

    const renderFilesCore = (files: FileModel[]) => {
        return files.map((file, index) => {
            return (
                <File file={file} key={`file_${index}`} isCompanyGroupFile={true} expectedIncludedEmployerCount={expectedIncludedEmployerCount} />
            )
        })
    }

    const padWithLeadingZeroes = (num: number, size: number) => {
        var numberString = num?.toString() ?? '';
        while (numberString.length < size) {
            numberString = "0" + numberString;
        }
        return numberString;
    }

    return (
        <>
        <div className={styles.infoCardContainer}>
            {renderFiles()}
        </div>
        </>
    )
}

export default CustomerGroupFilesByMonth

const useStyles = createUseStyles({
    container: {
        marginBottom: 40
    },
    card: {
        marginBottom: 20
    },
    infoCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        columnGap: 20
    },
    infoCard: {
        flex: 1,
        backgroundColor: Colors.grayBackgroundApp,
        minWidth: '100%'
    }
})
